import set from "lodash/set";
import cloneDeep from "lodash/cloneDeep";
import omit from "lodash/omit";
import { DEFAULT_CHECKOUT_SESSION_ATTRIBUTE_VALUES } from "utils/constants/stripe";
import { notNothing } from "utils/data";
import { getFieldPath } from "utils/form";

export const getCheckoutAttributeConfig = ({ name, attribute }) => ({
  attribute,
  path: getFieldPath(name, attribute)
});

export const getCheckoutAttributesConfig = ({ name, attributes }) =>
  Array.isArray(attributes)
    ? attributes.reduce((memo, attribute) => {
        if (attribute) {
          memo.push(getCheckoutAttributeConfig({ name, attribute }));
        } else {
          throw new Error("Missing attribute value");
        }

        return memo;
      }, [])
    : [];

export const getToggleCheckoutAttributesValues = ({
  touched,
  attributes,
  values,
  isTouched,
  active
}) => {
  let updatedTouched;
  if (!isTouched) {
    updatedTouched = cloneDeep(touched);
    attributes.forEach(({ path }) => {
      set(updatedTouched, path, true);
    });
  }
  /**
   * If not active then remove the entire attribute
   */
  let updatedValues;
  if (!active) {
    const omissions = attributes.map(({ path }) => path);
    updatedValues = omit(cloneDeep(values), omissions);
  } else {
    updatedValues = cloneDeep(values);
    attributes.forEach(({ path, attribute }) => {
      const defaultValues =
        DEFAULT_CHECKOUT_SESSION_ATTRIBUTE_VALUES[attribute];
      if (notNothing(defaultValues)) {
        set(updatedValues, path, defaultValues);
      }
    });
  }

  return {
    touched: updatedTouched,
    values: updatedValues
  };
};
